import { createContext, useState, useMemo, useCallback, type ReactNode } from 'react';

export interface SearchContextType {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const SearchContext = createContext<SearchContextType | undefined>(undefined);

export function SearchProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const handleSetOpen = useCallback((value: boolean) => {
    setOpen(value);
  }, []);

  const contextValue = useMemo(
    () => ({ open, setOpen: handleSetOpen }),
    [open, handleSetOpen]
  );

  return (
    <SearchContext.Provider value={contextValue}>
      {children}
    </SearchContext.Provider>
  );
}
